import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { type TOCTemplateProps } from '@on3/ui-lib/components/Subscription/Templates/TopOfContent';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';
import { createDescription } from '@public/utils/meta';
import clsx from 'clsx';

import styles from './On3PlusRivalsTOC.module.scss';

export const On3PlusRivalsTOC = ({
  handleJoin,
  template,
  preview,
  props,
}: TOCTemplateProps) => {
  const { currentSite } = useSite();
  const { subscribeText } = useSubscribe();

  const siteName = currentSite?.name;
  const lineOne = template.data.line1;
  const lineTwo = template.data.line2;
  const lineThree =
    template.data.line3 ||
    createDescription(
      'One subscription: The best {0} coverage and community, and all access to the On3 College Sports Network.',
    );
  const btnText = template.planData1?.buttonText || subscribeText || 'Join Now';
  const planKey = template.planKey1;

  return (
    <div className={styles.component}>
      <div
        className={clsx(styles.block, {
          [styles.preview]: preview,
        })}
        data-template-type="top-of-content"
        {...props}
      >
        <div className={styles.top}>
          <div className={styles.lineOne}>{lineOne}</div>
          <div className={styles.lineTwo}>{lineTwo}</div>
        </div>
        <div className={styles.middle}>
          {siteName && <div className={styles.siteName}>{siteName}</div>}
          <figure className={styles.logos}>
            {siteName && <div className={styles.plus}>+</div>}
            <ServiceLogo type="on3" />
            <div className={styles.plus}>+</div>
            <ServiceLogo type="rivals" />
          </figure>
        </div>
        <div className={styles.lineThree}>{lineThree}</div>
        <button
          className={styles.joinBtn}
          onClick={() => handleJoin(planKey)}
          type="button"
        >
          {btnText}
        </button>
      </div>
    </div>
  );
};
